module.exports = "<ng-content></ng-content> \n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/cta-box/cta-box.component.html
// module id = ./src/app/modules/common-module/components/cta-box/cta-box.component.html
// module chunks = 9